// extracted by mini-css-extract-plugin
export default {"productItem":"style_productItem__jkBaY","background":"style_background__BXQTn","header":"style_header__2a5-O","text":"style_text__Lzmab","active":"style_active__aWECM"};